import { booleanAttribute, Component, input, OnInit, output, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AddressFormComponent } from "src/app/components/address-form/address-form.component";
import { CardComponent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-address-card',
  standalone: true,
  imports: [
    CardComponent,
    TranslateModule,
    AddressFormComponent
],
  templateUrl: './address-card.component.html'
})
export class AddressCardComponent implements OnInit{
  @ViewChild('cardComponent') cardComponent!: CardComponent;

  index = input<number>();
  totalItems = input<number>();
  control = input.required<any>();
  remove = output<void>();
  disabled = input(false, { transform: booleanAttribute });

  ngOnInit(): void {
    if (this.disabled()) {
      this.control().disable();
    }
  }

  isFormInvalid(): void {
    if (this.control().invalid && this.cardComponent) {
      this.cardComponent.isOpen.set(true);
    }
  }
}
